var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** @jsx jsx */
import { faCreditCard } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createOpayoTransactionAction, createCustomerTransactionAction, CustomerTransactionStatus, useApi, defer, } from '@getclarauk/api-client';
import { padStart } from 'lodash';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { jsx } from 'theme-ui';
import { useOpayo } from './useOpayo';
import { Card } from '../components/Card';
import { Modal } from '../components/Modal';
import { useHtmlField } from '../hooks/useHtmlField';
import { clientConfig } from '../util/clientConfig';
import { dayjs } from '../util/dayjs';
export var OpayoCardForm = forwardRef(function (_a, ref) {
    var provider = _a.provider;
    var opayo = useOpayo(provider.sandbox);
    var cardNumber = useHtmlField('');
    var expMonth = useHtmlField('');
    var expYear = useHtmlField('');
    var cvv = useHtmlField('');
    var createOpayoTransaction = useApi(createOpayoTransactionAction)[0];
    var _b = useState(), transactionId = _b[0], setTransactionId = _b[1];
    var promiseRef = useRef();
    var yearRef = useRef(null);
    var cvvRef = useRef(null);
    var createCustomerTransaction = useApi(createCustomerTransactionAction)[0];
    useImperativeHandle(ref, function () {
        return {
            capture: function (options) {
                return __awaiter(this, void 0, void 0, function () {
                    var address, transaction, cardIdentifier, result, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!opayo) {
                                    return [2 /*return*/, { error: 'Could not take payment' }];
                                }
                                else if (!cardNumber.value) {
                                    return [2 /*return*/, { error: 'Enter a card number' }];
                                }
                                else if (!cardNumber.value.match(/^[0-9]{13,19}$/)) {
                                    return [2 /*return*/, { error: 'Enter a valid card number' }];
                                }
                                else if (!expMonth.value) {
                                    return [2 /*return*/, { error: 'Enter the expiry month' }];
                                }
                                else if (!expMonth.value.match(/^(0?[1-9]|1[12])$/)) {
                                    return [2 /*return*/, {
                                            error: 'Enter a number between 1 and 12 for the expiry month',
                                        }];
                                }
                                else if (!expYear.value) {
                                    return [2 /*return*/, { error: 'Enter the expiry year' }];
                                }
                                else if (!expYear.value.match(/^[0-9]{2}$/)) {
                                    return [2 /*return*/, {
                                            error: 'Enter a two digit number for the expiry year, e.g. "25" for 2025',
                                        }];
                                }
                                else if (dayjs(expMonth.value + '/' + expYear.value, 'M/YY')
                                    .endOf('month')
                                    .isBefore(dayjs())) {
                                    return [2 /*return*/, { error: 'The card expiry must be in the future' }];
                                }
                                else if (!cvv.value) {
                                    return [2 /*return*/, { error: 'Enter the security code' }];
                                }
                                else if (!cvv.value.match(/^[0-9]{3,4}$/)) {
                                    return [2 /*return*/, {
                                            error: 'For the security code, enter a 3 digit number (or a 4 digit number for American Express)',
                                        }];
                                }
                                address = options.address;
                                if (!address) {
                                    throw new Error('Need an address for this integration...');
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 5, , 6]);
                                return [4 /*yield*/, createCustomerTransaction({
                                        userId: options.userId,
                                        amount: options.amount,
                                        description: options.description,
                                        itemType: options.itemType,
                                        pharmacyId: options.pharmacyId,
                                        cardholderName: options.givenName + ' ' + options.familyName,
                                    })];
                            case 2:
                                transaction = _a.sent();
                                if (!(transaction === null || transaction === void 0 ? void 0 : transaction.session.opayo)) {
                                    return [2 /*return*/, { error: 'Error' }];
                                }
                                return [4 /*yield*/, opayo.tokeniseCardDetails(transaction.session.opayo.merchantSessionKey, {
                                        cardholderName: options.givenName + ' ' + options.familyName,
                                        cardNumber: cardNumber.value,
                                        expiryDate: padStart(expMonth.value, 2, '0') +
                                            padStart(expYear.value, 2, '0'),
                                        securityCode: cvv.value,
                                    })];
                            case 3:
                                cardIdentifier = _a.sent();
                                return [4 /*yield*/, createOpayoTransaction(__assign(__assign({}, options), { address: address, customerTransactionId: transaction._id, merchantSessionKey: transaction.session.opayo.merchantSessionKey, cardIdentifier: cardIdentifier, browserJavaEnabled: navigator.javaEnabled(), browserLanguage: navigator.language, browserColorDepth: '24', browserScreenHeight: window.screen.height.toString(), browserScreenWidth: window.screen.width.toString(), browserTZ: new Date().getTimezoneOffset().toString() }))];
                            case 4:
                                result = _a.sent();
                                if (result.status === CustomerTransactionStatus.Error) {
                                    return [2 /*return*/, { error: 'Unknown error' }];
                                }
                                else if (result.status === CustomerTransactionStatus.Failed) {
                                    return [2 /*return*/, { error: 'Declined' }];
                                }
                                else if (result.status === CustomerTransactionStatus.AcsRequired) {
                                    setTransactionId(transaction._id);
                                    promiseRef.current = defer();
                                    return [2 /*return*/, promiseRef.current.promise];
                                }
                                else {
                                    return [2 /*return*/, { customerTransactionId: transaction._id }];
                                }
                                return [3 /*break*/, 6];
                            case 5:
                                err_1 = _a.sent();
                                console.log(err_1);
                                return [2 /*return*/, { error: 'Error' }];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            },
        };
    });
    useEffect(function () {
        if (expMonth.value.match(/^[0-9]{2}$/) && yearRef.current) {
            yearRef.current.focus();
        }
    }, [expMonth.value]);
    useEffect(function () {
        if (expYear.value.match(/^[0-9]{2}$/) && cvvRef.current) {
            cvvRef.current.focus();
        }
    }, [expYear.value]);
    var onMessage = useCallback(function (e) {
        var _a, _b, _c;
        if (((_a = e.data) === null || _a === void 0 ? void 0 : _a.source) !== 'claraACS')
            return;
        if (e.data.status === 'success') {
            (_b = promiseRef.current) === null || _b === void 0 ? void 0 : _b.resolve({ customerTransactionId: transactionId });
        }
        else if (e.data.status === 'error') {
            (_c = promiseRef.current) === null || _c === void 0 ? void 0 : _c.resolve({ error: 'Declined' });
        }
        else {
            return;
        }
        setTransactionId(undefined);
    }, [transactionId]);
    useEffect(function () {
        window.addEventListener('message', onMessage, false);
        return function () {
            window.removeEventListener('message', onMessage, false);
        };
    }, [onMessage]);
    return (jsx("div", null,
        jsx("div", { sx: { color: 'secondary' } }, "Card details"),
        jsx(Card, { sx: {
                mt: 2,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                '&>input': {
                    border: 'none',
                    fontSize: 2,
                    fontFamily: 'body',
                    px: 1,
                    py: 2,
                },
                maxWidth: 600,
            } },
            jsx(FontAwesomeIcon, { icon: faCreditCard, sx: { mx: 2, color: 'muted' } }),
            jsx("input", { type: "text", placeholder: "Card number", value: cardNumber.value, onChange: cardNumber.onChange, onBlur: cardNumber.validate, sx: { flex: 1 }, autoComplete: "cc-number" }),
            jsx("input", { type: "text", placeholder: "MM", value: expMonth.value, onChange: expMonth.onChange, onBlur: expMonth.validate, sx: { width: 30 }, autoComplete: "cc-exp-month" }),
            jsx("span", { sx: { color: 'muted' } }, "/"),
            jsx("input", { type: "text", placeholder: "YY", value: expYear.value, onChange: expYear.onChange, onBlur: expYear.validate, sx: { width: 30 }, ref: yearRef, autoComplete: "cc-exp-year" }),
            jsx("input", { type: "text", placeholder: "CVV", value: cvv.value, onChange: cvv.onChange, onBlur: cvv.validate, sx: { width: 60 }, ref: cvvRef, autoComplete: "cc-csc" })),
        transactionId && (jsx(Modal, { sx: { maxWidth: 400 } },
            jsx("iframe", { title: "3D Secure", src: "".concat(clientConfig.apiUrl, "/opayo/acs/").concat(transactionId), sx: { width: '100%', height: 450, border: 'none', margin: '4px' } })))));
});
//# sourceMappingURL=OpayoCardForm.js.map